<template>
  <div class="w-full">
    <SocialAuthButton
      :icon="GoogleIcon"
      class="mt-8"
      @click="registerWithGoogleAction"
    >
      {{ $t('continue_google') }}
    </SocialAuthButton>

    <SocialAuthButton
      :icon="AppleIcon"
      class="mt-5"
      @click="registerWithAppleAction"
    >
      {{ $t('continue_apple') }}
    </SocialAuthButton>
  </div>
</template>

<script setup>
import GoogleIcon from '@/assets/icons/GoogleIcon.vue'
import AppleIcon from '@/assets/icons/AppleIcon.vue'
import SocialAuthButton from '@/components/buttons/social-auth/SocialAuthButton.vue'
import { getAppleLoginLink, getGoogleLoginLink } from '@/services/api/Auth'
import { logAuthEvent, sanitizeUrlForLog } from '@/services/debug/authDebug'
import { changeWindowLocation, getAppAuthUrl } from '@/services/auth/Auth.service'
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()

const registerWithAppleAction = async () => {
  const redirectUri = getAppAuthUrl()
  const appleRegisterLink = getAppleLoginLink({
    redirectUri,
    language: locale.value
  })
  logAuthEvent('auth.social.apple.started', {
    language: locale.value,
    redirectUri: sanitizeUrlForLog(redirectUri),
    targetUrl: sanitizeUrlForLog(appleRegisterLink)
  })
  changeWindowLocation(appleRegisterLink)
}

const registerWithGoogleAction = async () => {
  const redirectUri = getAppAuthUrl()
  const googleRegisterLink = getGoogleLoginLink({
    redirectUri,
    language: locale.value
  })
  logAuthEvent('auth.social.google.started', {
    language: locale.value,
    redirectUri: sanitizeUrlForLog(redirectUri),
    targetUrl: sanitizeUrlForLog(googleRegisterLink)
  })
  changeWindowLocation(googleRegisterLink)
}
</script>
